import Loadable from 'mk2/helpers/Loadable';

const InfiniteListLoadable = Loadable({
    loader: () => import('mk2/components/InfiniteList' /* webpackChunkName: "InfiniteList" */),
    modules: ['mk2/components/InfiniteList'],
    webpack: () => [require.resolveWeak('mk2/components/InfiniteList')],
});

export default InfiniteListLoadable;
